import React, { Component } from 'react'
import _ from 'lodash'
import fir from 'firebase/app'
import { Button, Label, Icon, Segment, Input, Header, Tab, Form } from 'semantic-ui-react'
import firebase from '../../../config/firebase'

export default class OrderConfiguration extends Component {
  constructor() {
    super()

    this.state = {
      loading: false,
      saving: false,
      reason: '',
      keyCode: '',
      reasons: {},
    }
  }

  componentDidMount() {
    this.syncOrderReason()
  }

  componentWillUnmount() {
    if (this.orderReasonSubscribe) {
      this.orderReasonSubscribe.off()
    }
  }

  onChangeText = (field, value) => {
    this.setState({
      [field]: value,
    })
  }

  onRemove = reasonKey => {
    const confirmation = window.confirm('Are you sure to remove the reason?')

    if (confirmation) {
      firebase
        .database()
        .ref(`reasons/order/${reasonKey}`)
        .remove()
    }
  }

  onSubmit = () => {
    const self = this
    const { reason, keyCode } = this.state

    const reasonKey = firebase
      .database()
      .ref(`reasons/order`)
      .push().key

    const confirmation = window.confirm('Do you want to save new reaon?')

    if (confirmation) {
      const updates = {}
      this.setState({ saving: true })

      updates[`reasons/order/${reasonKey}/text`] = reason.trim()
      updates[`reasons/order/${reasonKey}/key_code`] = keyCode
      updates[`reasons/order/${reasonKey}/created_at`] = fir.database.ServerValue.TIMESTAMP

      firebase
        .database()
        .ref()
        .update(updates)
        .then(err => {
          if (err) {
            alert(err)
          }

          self.setState({ saving: false, reason: '', keyCode: '' })
        })
    }
  }

  syncOrderReason() {
    this.setState({ loading: true })

    this.orderReasonSubscribe = firebase.database().ref('reasons/order')

    this.orderReasonSubscribe.on('value', snapshot => {
      const reasons = snapshot.val()

      this.setState({
        loading: false,
        reasons,
      })
    })
  }

  renderReasonList() {
    const { reasons } = this.state

    if (_.size(reasons) > 0) {
      return _.map(reasons, (reason, reasonKey) => {
        return (
          <Segment key={reasonKey}>
            <div className="reason-wrapper">
              <div style={{ display: 'flex', flex: 1, alignItems: 'center' }}>
                <Label style={{ marginRight: 10 }}>{reason.key_code}</Label>
                {reason.text}
              </div>
              <div style={{ display: 'flex' }}>
                <Button icon size="mini" color="red" onClick={() => this.onRemove(reasonKey)}>
                  <Icon name="trash" />
                </Button>
              </div>
            </div>
          </Segment>
        )
      })
    }

    return <div>No results</div>
  }

  render() {
    const { loading, reason, keyCode, reasons, saving } = this.state

    return (
      <Tab.Pane attached={false} className="configuration-tab">
        <Header size="large">Add Cancel Reason</Header>
        <Form loading={loading} onSubmit={this.onSubmit}>
          <Form.Group widths="equal">
            <Form.Field
              control={Input}
              required
              value={reason}
              label="Reason"
              placeholder="Enter your reason here"
              onChange={e => this.onChangeText('reason', e.target.value)}
            />
            <Form.Field
              control={Input}
              required
              value={keyCode}
              label="Key Code"
              placeholder="Enter reason KEY CODE"
              onChange={e => this.onChangeText('keyCode', e.target.value)}
            />
          </Form.Group>

          <Button type="submit" loading={saving} disabled={reason.length === 0}>
            Add
          </Button>
        </Form>
        <div style={{ height: 1, margin: '20px 0px' }} />
        <Header size="large">All Reason({_.size(reasons)})</Header>
        {this.renderReasonList()}
      </Tab.Pane>
    )
  }
}



// WEBPACK FOOTER //
// ./src/containers/configurations/Reason/index.js